"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deferred = void 0;
class Deferred {
    constructor(settledPromise) {
        this.resolve = () => {
        };
        this.reject = () => {
        };
        if (settledPromise) {
            this.promise = settledPromise;
        }
        else {
            this.promise = new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        }
    }
}
exports.Deferred = Deferred;
//# sourceMappingURL=Deferred.js.map